import { UAParser } from 'ua-parser-js';

const DEFAULT_OS_VERSION = '0';
const DEFAULT_DEVICE_VENDOR = 'Unknown';
const DEFAULT_DEVICE_MODEL = 'Unknown';

function getBrowserMinorVersion(browserVersion?: string): string | undefined {
    if (!browserVersion) {
        return browserVersion;
    }

    return browserVersion.substring(browserVersion.indexOf('.') + 1);
}

interface Browser extends IUAParser.IBrowser {
    minor?: string;
}

interface DeviceInfo {
    browser?: Browser;
    operationSystem?: string;
    operationSystemMajorVersion: string;
    operationSystemMinorVersion: string;
    deviceVendor: string;
    deviceModel: string;
}

export function getDeviceInfo(): DeviceInfo {
    const parser = new UAParser();

    const currentBrowser = parser.getBrowser();
    const currentOS = parser.getOS();
    const [operationSystemMajorVersion, ...operationSystemRestVersions] =
        currentOS.version?.split('.') || [];

    const device = parser.getDevice();

    return {
        browser: {
            ...currentBrowser,
            minor: getBrowserMinorVersion(currentBrowser.version),
        },
        operationSystem: currentOS.name,
        operationSystemMajorVersion: operationSystemMajorVersion || DEFAULT_OS_VERSION,
        operationSystemMinorVersion: operationSystemRestVersions?.join('.') || DEFAULT_OS_VERSION,
        deviceVendor: device.vendor ?? DEFAULT_DEVICE_VENDOR,
        deviceModel: device.model ?? DEFAULT_DEVICE_MODEL,
    };
}
